import { Component, OnInit, OnDestroy } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { NewsService } from 'src/app/services/news/news.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {
  sub: Subscription[] = [];
  customOptions: OwlOptions = {
    loop: true,
    margin: 10,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<', '>'],
    autoplay: true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 3
      }
    },
    nav: true
  }
  notices: any[] = [
    {
      id: '1',
      name: 'BA LL.B Date Sheet for External Viva, May-2026',
      date: '07',
      monthYear: 'May 2026',
      pdfUrl: 'assets/pdf/notices/External Viva Schedule, May 2026.pdf'
    },
    {
      id: '2',
      name: 'NOTIFICATION FOR UPCOMING ANNUAL SPORTS MEET 2025',
      date: '20',
      monthYear: 'April 2025',
    },
    {
      id: '3',
      name: 'IMPORTANT NOTICE REGARDING END TERM EXAMINATION',
      date: '10',
      monthYear: 'June 2025',
    }
  ];
  events: any[] = [
    {
      id: '1',
      name: 'Online Faculty Development Program, 2025 On "Legal Education in Digital Age"',
      date: '15',
      monthYear: 'April 2025',
    },
    {
      id: '2',
      name: 'One Week FDP (Online) 17-23 April, 2025',
      date: '24',
      monthYear: 'March 2025',
    },
    {
      id: '3',
      name: 'Rakesh Aggarwal Memorial National Conference, 2025',
      date: '23',
      monthYear: 'January 2025',
    },
  ];
  encodeURL(url: string | undefined): string {
    if (!url) return '';
    try {
      // Decode first to prevent double-encoding already encoded S3 URLs (e.g. converting %20 to %2520)
      const decoded = decodeURIComponent(url);
      return encodeURI(decoded);
    } catch (e) {
      try {
        const decoded = decodeURI(url);
        return encodeURI(decoded);
      } catch (err) {
        if (url.includes('%')) {
          return url;
        }
        return encodeURI(url);
      }
    }
  }

  isAttachmentURL(value: string, keyName: string): boolean {
    if (!value || typeof value !== 'string') return false;
    const valLower = value.toLowerCase().trim();

    return (
      valLower.startsWith('http://') ||
      valLower.startsWith('https://') ||
      valLower.startsWith('assets/') ||
      valLower.includes('firebasestorage') ||
      valLower.includes('/notices/') ||
      valLower.includes('/uploads/') ||
      valLower.includes('.pdf') ||
      valLower.includes('.png') ||
      valLower.includes('.jpg') ||
      valLower.includes('.jpeg') ||
      valLower.includes('.webp') ||
      valLower.includes('.gif') ||
      valLower.includes('.svg')
    );
  }

  resolveAttachments(val: any): { pdfUrl: string, imageUrl: string } {
    let pdfUrl = '';
    let imageUrl = '';

    // First check explicit fields to preserve their direct assignments if they exist
    if (val.pdfUrl && typeof val.pdfUrl === 'string') pdfUrl = val.pdfUrl.trim();
    else if (val.pdfURL && typeof val.pdfURL === 'string') pdfUrl = val.pdfURL.trim();
    else if (val.pdf && typeof val.pdf === 'string') pdfUrl = val.pdf.trim();

    if (val.imageUrl && typeof val.imageUrl === 'string') imageUrl = val.imageUrl.trim();
    else if (val.image && typeof val.image === 'string') imageUrl = val.image.trim();
    else if (val.img && typeof val.img === 'string') imageUrl = val.img.trim();
    else if (val.imageURL && typeof val.imageURL === 'string') imageUrl = val.imageURL.trim();
    else if (val.photo && typeof val.photo === 'string') imageUrl = val.photo.trim();
    else if (val.pic && typeof val.pic === 'string') imageUrl = val.pic.trim();

    // Now, scan all fields (including the generic ones) to classify them
    for (const key in val) {
      if (val.hasOwnProperty(key) && typeof val[key] === 'string') {
        const valueStr = val[key].trim();
        if (this.isAttachmentURL(valueStr, key)) {
          const lowerKey = key.toLowerCase();
          const lowerValue = valueStr.toLowerCase();

          const hasPdfExt = lowerValue.includes('.pdf') || lowerValue.includes('.pdf?');
          const hasImgExt = lowerValue.includes('.png') || 
                            lowerValue.includes('.jpg') || 
                            lowerValue.includes('.jpeg') || 
                            lowerValue.includes('.webp') || 
                            lowerValue.includes('.gif') || 
                            lowerValue.includes('.svg');

          if (hasPdfExt) {
            if (!pdfUrl) pdfUrl = valueStr;
          } else if (hasImgExt) {
            if (!imageUrl) imageUrl = valueStr;
          } else {
            if (lowerKey.includes('pdf')) {
              if (!pdfUrl) pdfUrl = valueStr;
            } else if (
              lowerKey.includes('image') ||
              lowerKey.includes('img') ||
              lowerKey.includes('photo') ||
              lowerKey.includes('pic')
            ) {
              if (!imageUrl) imageUrl = valueStr;
            } else {
              if (!pdfUrl && !imageUrl) {
                pdfUrl = valueStr;
              }
            }
          }
        }
      }
    }

    return { pdfUrl, imageUrl };
  }

  parseDate(dateStr: string, monthYearStr?: string): { date: string, month: string, year: string } {
    if (!dateStr) {
      let month = '';
      let year = '';
      if (monthYearStr) {
        const parts = monthYearStr.trim().split(/\s+/);
        if (parts.length >= 2) {
          month = parts[0];
          year = parts[1];
        } else {
          month = monthYearStr;
        }
      }
      return { date: '', month, year };
    }

    const trimmed = dateStr.trim();
    if (trimmed.length <= 2) {
      let month = '';
      let year = '';
      if (monthYearStr) {
        const parts = monthYearStr.trim().split(/\s+/);
        if (parts.length >= 2) {
          month = parts[0];
          year = parts[1];
        } else {
          month = monthYearStr;
        }
      }
      return { date: trimmed, month, year };
    }

    const parts = trimmed.split(/[-/]/);
    if (parts.length >= 3) {
      let day = parts[0].trim();
      let month = parts[1].trim();
      let year = parts[2].trim();

      if (day.length === 4) {
        const temp = day;
        day = year;
        year = temp;
      }

      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      let monthName = month;
      const monthIdx = parseInt(month, 10);
      if (!isNaN(monthIdx) && monthIdx >= 1 && monthIdx <= 12) {
        monthName = monthNames[monthIdx - 1];
      }

      return {
        date: day,
        month: monthName,
        year: year
      };
    }

    try {
      const d = new Date(trimmed);
      if (!isNaN(d.getTime())) {
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const monthName = monthNames[d.getMonth()];
        const year = String(d.getFullYear());
        return {
          date: day,
          month: monthName,
          year: year
        };
      }
    } catch (e) {
      // Ignore
    }

    return { date: trimmed, month: monthYearStr || '', year: '' };
  }

  constructor(private newsService: NewsService) { }

  ngOnInit(): void {
    // Parse hardcoded notices
    this.notices = this.notices.map((item) => {
      const parsed = this.parseDate(item.date || '', item.monthYear || '');
      return {
        ...item,
        date: parsed.date,
        month: parsed.month,
        year: parsed.year
      };
    });

    // Parse hardcoded events
    this.events = this.events.map((item) => {
      const parsed = this.parseDate(item.date || '', item.monthYear || '');
      return {
        ...item,
        date: parsed.date,
        month: parsed.month,
        year: parsed.year
      };
    });

    // 1. Fetch Dynamic Notices
    this.newsService.getNoticesList();
    this.sub[0] = this.newsService.noticesList.snapshotChanges().subscribe((list) => {
      const items = list.map((item) => {
        const val = item.payload.val() || {};
        const dateInfo = this.parseDate(val.date || '', val.monthYear || '');
        const attachments = this.resolveAttachments(val);

        return {
          id: item.key,
          name: val.name || val.title || '',
          date: dateInfo.date,
          month: dateInfo.month,
          year: dateInfo.year,
          pdfUrl: attachments.pdfUrl,
          imageUrl: attachments.imageUrl
        };
      });
      if (items.length > 0) {
        this.notices = items.reverse();
      }
    });

    // 2. Fetch Dynamic Events
    this.newsService.getEventsList();
    this.sub[1] = this.newsService.eventsList.snapshotChanges().subscribe((list) => {
      const items = list.map((item) => {
        const val = item.payload.val() || {};
        const dateInfo = this.parseDate(val.date || '', val.monthYear || '');
        const attachments = this.resolveAttachments(val);

        return {
          id: item.key,
          name: val.name || val.title || '',
          date: dateInfo.date,
          month: dateInfo.month,
          year: dateInfo.year,
          pdfUrl: attachments.pdfUrl,
          imageUrl: attachments.imageUrl
        };
      });
      if (items.length > 0) {
        this.events = items.reverse();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.forEach(s => s.unsubscribe());
  }

}
